import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Orc extends Mob {
	constructor(sprites, infoable=true) {
		super(sprites, StandardSheetAnimations.getAnimation("orc"));
		this.substAnimation("idle_e",1, { col: 0 });
		this.substAnimation("idle_w",1, { col: 0 });
		this.width = Game.ENEMY_WIDTH;
		this.height = Game.ENEMY_HEIGHT;

		let traits = {
			clas: "enemy",
			race: "orc",
			openDoors: true,
			static: false,
			qi: BasicAI.QI_MEDIUM,
			speed: Orc.WALK_STEP * Game.MULT,
			radius: Orc.RADIUS,
			runspeed: Orc.RUN_STEP * Game.MULT,
			timeWarns: Orc.TIME_WARNS,
			infoable: infoable
		}
		this.setMobTraits(traits)
	}
	init() {
		this.mc = jQuery("#template-mob").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}
Orc.RADIUS = 6;
Orc.WALK_STEP = 2;
Orc.RUN_STEP = 4;
Orc.TIME_WARNS = [500,750];
